var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card", { staticClass: "mt-8 pa-4" }, [
    _c("div", { staticClass: "action-bar" }, [
      _c("div", { staticClass: "headline page-title" }, [
        _vm._v(_vm._s(_vm.pageTitle))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _vm.addNew
            ? _c(
                "v-btn",
                {
                  staticClass: "add-new",
                  on: {
                    click: function($event) {
                      return _vm.addNew()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("mdi-plus")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("New")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }